const CourseService = {
    calculateProgress: (item) => {
        const progress = item.attributes.progress ?? {};
        const totalLessons = CourseService.getLessonCount(item.attributes.course.data);
        const totalQuizzes = CourseService.getQuizCount(item.attributes.course.data);
        const totalSections = totalLessons + totalQuizzes;
        const completedSections = Object.keys(progress)?.length;
        return ((completedSections / totalSections) * 100).toFixed(0);
    },
    calculateScore: (correctQuestions, totalQuestions) => {
        return (correctQuestions / totalQuestions) * 100;
    },
    getLessonCount: (course) => {
        const lessonTypes = ["ComponentCoursesLessons", "ComponentCoursesEmbed", "ComponentCoursesFile"];
        return course.attributes.Lessons?.filter((lesson) => lessonTypes.includes(lesson.__typename)).length;
    },
    getQuizCount: (course) => {
        return course.attributes.Lessons?.filter((quiz) => quiz.__typename === "ComponentCoursesQuizzes").length;
    },
    getTags: (course) => {
        return course.attributes.categories.data?.map((category) => category.attributes.name);
    },
};

export default CourseService;
